import type { CoverLetterDocumentType } from '@xing-com/crate-lebenslauf-shared-client-document-variable';

import { PROFESSIONAL_INFORMATION_DEFAULTS } from '../const';
import type { EditPersonalInformation } from '../types/SharedActions';

import { deserializeName } from './deserializeName';
import { updateLocalStorage } from './updateLocalStorage';

export const editPersonalInformation = (
  value: EditPersonalInformation['value']
): void => {
  const { name } = deserializeName(value.name);
  updateLocalStorage(`personalInformation.${name}`, value.value);
};

export const addProfessionalInformationFields = (
  doc: CoverLetterDocumentType
): void => {
  const professionalExperience = [
    ...(doc.professionalExperience ?? []),
    PROFESSIONAL_INFORMATION_DEFAULTS,
  ];

  updateLocalStorage(`professionalExperience`, professionalExperience);
};
